import React, { useState } from 'react'
import { Box, Checkbox, CircularProgress } from '@mui/material'
import { LoadingPage } from '../models/File'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

interface ScrollableImageContainerProps {
  pages: LoadingPage[]
  widthTrim?: number
  checkBox?: {
    showCheckbox: boolean
    onImageCheckBoxClick: (pageId: string) => void
  }
  onImageClick?: (pageId: string) => void
}

const ScrollableImageContainer: React.FC<ScrollableImageContainerProps> = ({
  pages,
  widthTrim,
  checkBox,
  onImageClick,
}) => {
  const drawings = useSelector((state: RootState) => state.drawings)
  const [checkePageId, setCheckePageId] = useState<string>('')

  const onPageChecked = (pageId: string) => {
    const selectedPageId = checkePageId === pageId ? '' : pageId
    setCheckePageId(selectedPageId)
    checkBox?.onImageCheckBoxClick(selectedPageId)
  }

  const isPageChecked = (page: LoadingPage) => {
    const existingPage = pages.find((p) => p.id === page.id)
    return existingPage && existingPage.id === checkePageId
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
        overflowX: 'auto',
        overflowY: 'scroll',
        height: '100%',
        width: '100%',
        pb: '4px',
        gap: 1,
        maxWidth: `calc(100% - ${widthTrim}px)`,
        '&::-webkit-scrollbar': {
          width: '5px',
          height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#56003D',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#56003D',
        },
      }}
    >
      {pages.map((page, index) =>
        page.isLoading ? (
          <Box
            key={index}
            sx={{
              display: 'flex',
              boxSizing: 'border-box',
              flex: '0 0 auto',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '75px',
              borderRadius: '8px',
              border: '1px solid #D8D8D8',
              mr: 1,
            }}
          >
            <CircularProgress sx={{ color: '#56003D' }} />
          </Box>
        ) : (
          <Box
            key={index}
            onClick={onImageClick ? () => onImageClick(page.id) : () => {}}
            sx={{
              position: 'relative',
              flex: '0 0 auto',
              height: '82px',
              boxSizing: 'border-box',
              mb: 1,
              border:
                drawings.selectedPageId === page.id
                  ? '1px solid #3F69FF'
                  : '1px solid #D8D8D8',
            }}
          >
            {checkBox?.showCheckbox && (
              <Checkbox
                checked={isPageChecked(page)}
                onChange={() => onPageChecked(page.id)}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  padding: '2px',
                  color: '#3F69FF',
                  '&.Mui-checked': {
                    color: '#3F69FF',
                  },
                }}
              />
            )}
            <img
              src={page.image}
              alt={`Page ${index + 1}`}
              style={{
                width: '100%',
                height: '82px',
                objectFit: 'cover',
              }}
            />
          </Box>
        ),
      )}
    </Box>
  )
}

export default ScrollableImageContainer
